<template>
  <v-container>
    <c-card class="white">
      <v-row align="center">
        <v-col cols="12" sm="6" md="2" class="black--text">
          <span>차량 번호</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{selectedVehicle.plateNo}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">차종</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{selectedVehicle.seatCnt ? selectedVehicle.seatCnt.configName : '-'}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">차량 등록일</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{selectedVehicle.registrationDate}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">차량 만료일</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{selectedVehicle.expirationDate}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">H/W 장착 여부</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{reqGetHwUsage}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">정기 점검일</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{selectedVehicle.inspectionDate}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">차량 모델명</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{ selectedVehicle.vehicleModel ? selectedVehicle.vehicleModel.modelName : '-' }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">차량 옵션</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>{{reqGetVehicleOption}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">담당 기사1</span>
        </v-col>
        <v-col cols="12" sm="6" md=10>
          <span style="cursor: pointer" @click="selectedVehicle.mainDriver ? $router.push(`/drivers/${selectedVehicle.mainDriver.id}`) : ''" >{{selectedVehicle.mainDriver ? selectedVehicle.mainDriver.name : '-'}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">담당 기사2</span>
        </v-col>
        <v-col cols="12" sm="6" md="10">
          <span style="cursor: pointer" @click="selectedVehicle.subDriver1 ? $router.push(`/drivers/${selectedVehicle.subDriver1.id}`) : ''">{{selectedVehicle.subDriver1 ? selectedVehicle.subDriver1.name : '-'}}</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="black--text">담당 기사3</span>
        </v-col>
        <v-col cols="12" sm="6" md="10">
          <span style="cursor: pointer" @click="selectedVehicle.subDriver2 ? $router.push(`/drivers/${selectedVehicle.subDriver2.id}`) : ''" >{{selectedVehicle.subDriver2 ? selectedVehicle.subDriver2.name : '-'}}</span>
        </v-col>
      </v-row>
    </c-card>
  </v-container>
  
</template>

<script>
  export default {
    data(){
      return {
        vehicleId : this.$route.params.vehicleId,
        selectedVehicle : {},
      }
    },
    mounted() {
      this.reqVehicleInfo();
    },
    methods : {
      async reqVehicleInfo() {
        const res = await this.$api.getVehicle(this.vehicleId);
        this.selectedVehicle = res.data;
      },
    },
    computed: {
      reqGetHwUsage(){
        const regHwUsage = this.selectedVehicle.hwUsage;
        let  hwUsage= "";
        if (regHwUsage === "Y"){
          hwUsage = "장착"
        }else if (regHwUsage === "N"){
          hwUsage = "미장착"
        }else if (regHwUsage === "NA"){
          hwUsage = "이용불가"
        }
        return hwUsage;
      },
      reqGetVehicleOption (){
        let vehicleOption = [];
        if (this.selectedVehicle.vehicleOption) {
          let options = this.selectedVehicle.vehicleOption.split(',');

          options.forEach((option) => {
            if (option === 'c_wcl'){
              vehicleOption.push("휠체어 리프트");
            }else {
              vehicleOption.push("없음");
            }
          });
          return vehicleOption.toString();
        }
      }
    }
  }
</script>

<style scoped>

</style>